import styled from '@emotion/styled';
import { colors } from 'ui_system/compass/utils';
import { FormattedMessage } from 'react-intl';

const PaymentHeader = styled.h2`
  color: ${colors.text.primary};
  font-size: 16px;
  margin: 47px 0 22px;
  text-transform: uppercase;
`;

const PaymentStep = styled.span`
  border-radius: 50%;
  border: 1px solid;
  display: inline-block;
  height: 32px;
  line-height: 32px;
  margin-right: 15px;
  text-align: center;
  width: 32px;
`;

const PaymentIcon = styled.i`
  color: ${colors.text.icon};
  font-size: 24px;
  height: 24px;
  margin-left: 5px;
  vertical-align: middle;
`;

type PaymentStepHeaderProps = {
  stepNumber: string;
  showPersonalSection: boolean;
};

export const PaymentStepHeader = ({
  stepNumber,
  showPersonalSection,
}: PaymentStepHeaderProps) => {
  return (
    <div>
      <PaymentHeader>
        {showPersonalSection && (
          <PaymentStep className="step">{stepNumber}</PaymentStep>
        )}
        <FormattedMessage
          id="PAYMENT_INFORMATION"
          defaultMessage="Payment Information"
        />
        <PaymentIcon className="af-lock brand-color" data-testid="lock" />
      </PaymentHeader>
    </div>
  );
};
